import { Select } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Control, Controller, useFormContext } from 'react-hook-form';

import { ByggType } from '../../../../../utils/registerEnums';
import { AboutFormData } from '../../types';

interface ByggtypeSelectProps {
  control: Control<AboutFormData>;
}

export const ByggtypeSelect: FC<ByggtypeSelectProps> = ({ control }) => {
  const { t } = useTranslation();

  const { getValues } = useFormContext<AboutFormData>();

  const registrationId = getValues().registreringId;

  const options = [
    {
      disabled: true,
      label: t('register.byggType.option.default'),
      value: -1
    },
    ...[
      ByggType.Enebolig,
      ByggType.EneboligMedUtleiedel,
      ByggType.TomannsboligHorisontalDelt,
      ByggType.TomannsboligVertikalDelt,
      ByggType.Firemannsbolig,
      ByggType.KjedetEnebolig,
      ByggType.Rekkehus,
      ByggType.Fritidsbolig,
      ByggType.AnnetSmahus,
      ByggType.Leilighet,
      ByggType.AnnenBolig
    ].map((byggType) => ({
      label: t(`buildingCategory.${byggType}`),
      value: byggType
    }))
  ];

  return (
    <Controller
      control={control}
      name="bygginfo.type"
      rules={{ required: t('register.bygningsdetaljer.boligtype.error') }}
      render={({ field: { value, onChange, ...rest }, fieldState: { error } }) => (
        <Select
          label={t('register.bygningsdetaljer.boligtype.label')}
          required
          disabled={!!registrationId}
          options={options}
          value={value ?? -1}
          onChange={({ currentTarget: { value: val } }) => onChange(val)}
          error={!!error}
          helperText={error && t(`${error.message}`)}
          {...rest}
        />
      )}
    />
  );
};
